import styled, { css } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const SwitchToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._6};
`;

interface IToggleWrapper {
  readonly height: string;
}

export const ToggleWrapper = styled.ul<IToggleWrapper>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${SPACING._4};
  gap: ${SPACING._4};
  border-radius: ${SPACING._6};
  background-color: ${({ theme }) => theme.neutral950};
  position: relative;
  overflow: hidden;
  isolation: isolate;
  height: ${({ height }) => height};
`;

export const ToggleItem = styled.li<{
  withoutHoverColor: boolean;
  disabled: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._6};
  padding: ${SPACING._4};
  height: 100%;
  user-select: none;
  cursor: pointer;

  span,
  svg,
  div {
    transition: 200ms;
    z-index: 11;
  }

  span {
    width: 100%;
    text-align: center;
  }

  ${({ withoutHoverColor, disabled, theme }) =>
    !withoutHoverColor &&
    !disabled &&
    css`
      &:hover {
        span {
          color: ${theme.neutral50};
        }

        svg {
          fill: ${theme.neutral50};
        }
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const ToggleItemOverflow = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.primary};
  border-radius: ${SPACING._4};
  height: calc(100% - 8px);
  transition: 200ms;
  z-index: 10;
`;
